// extracted by mini-css-extract-plugin
export default {"background":"create_background__lGDBU"};